import * as NS from './namespace';
import { IIndicator, ISensorDevice } from '@/model/meta';
import { IIndicatorValue } from '@/model/datamart';

const mutations: NS.IViewingMutations = {
    SET_LOADING_REQUEST(state: NS.IViewingState): void {
        state.preloader = true;
        state.failLoading = false;
    },
    SET_LOADING_FAIL(state: NS.IViewingState): void {
        state.preloader = false;
        state.failLoading = true;
    },
    SET_FORM_REQUEST(state: NS.IViewingState): void {
        state.activeFormRequest = true;
        state.failedFormRequest = false;
    },
    SET_FORM_REQUEST_FAIL(state: NS.IViewingState): void {
        state.activeFormRequest = false;
        state.failedFormRequest = true;
    },
    SET_FORM_REQUEST_RESET(state: NS.IViewingState): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
    },

    SET_ACTIVEDEVICES_SUCCESS(state: NS.IViewingState, payload: ISensorDevice[]): void {
        payload.forEach(item => {
            item['availableIndicators'] = [];
        });
        state.activeDevices = payload;
    },
    SET_ABAILABLEINDICATORS_SUCCESS(state: NS.IViewingState, payload: {device: ISensorDevice, indicators: IIndicator[]}): void {
        const device = state.activeDevices.find(item => {
            return item.sensorDeviceId === payload.device.sensorDeviceId;
        });
        if (device !== undefined && (device.availableIndicators === undefined || device.availableIndicators.length === 0)) 
            device.availableIndicators = payload.indicators;
        state.abailableIndicators = payload.indicators;
    },
    CLEAN_ABAILABLEINDICATORS(state: NS.IViewingState, payload: any): void {
        state.abailableIndicators = [];
    },

    SET_VALUESGRID_SUCCESS(state: NS.IViewingState, payload: IIndicatorValue[]): void {
        payload.forEach(item => {
            item.timestamp = new Date(item.timestamp);
        });
        state.indictorValuesGrid = payload;
        state.preloader = false;
        state.failLoading = false;
    },

    SET_VALUESGRIDS_SUCCESS(state: NS.IViewingState, payload: { [key: string]: IIndicatorValue[] }): void {
        for (const key in payload) {
            const value = payload[key];
            value.forEach(item => {
                item.timestamp = new Date(item.timestamp);
            });
        }
        state.indictorValuesGrids = payload;
        state.preloader = false;
        state.failLoading = false;
    },


    SET_INSERT_INDICATORVALUE(state: NS.IViewingState, payload: IIndicatorValue): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.indictorValuesGrid.findIndex(x => x.indicatorId !== payload.indicatorId);
        if (index >= 0) {
            state.indictorValuesGrid = [];
        }
        state.indictorValuesGrid.push(payload);
    },

    SET_DELETE_INDICATORVALUE(state: NS.IViewingState, payload: IIndicatorValue): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.indictorValuesGrid.findIndex(x => x.indicatorValueId === payload.indicatorValueId);
        state.indictorValuesGrid.splice(index, 1);
    },

    SET_UPDATE_INDICATORVALUE(state: NS.IViewingState, payload: IIndicatorValue): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
        const index = state.indictorValuesGrid.findIndex(x => x.indicatorValueId === payload.indicatorValueId);
        state.indictorValuesGrid.splice(index, 1, payload);
    },

    RESET_INDICATORVALUES(state: NS.IViewingState, payload: any): void {
        state.indictorValuesGrid = [];
    },

    RESET_INDICATORSVALUES(state: NS.IViewingState, payload: any): void {
        state.indictorValuesGrids = {};
    },

    SET_UPLOAD_REQUEST(state: NS.IViewingState): void {
        state.activeUploadRequest = true;
        state.failedUploadRequest = false;
        state.successUploadRequest = false;
    },
    SET_UPLOAD_REQUEST_FAIL(state: NS.IViewingState): void {
        state.activeUploadRequest = false;
        state.failedUploadRequest = true;
        state.successUploadRequest = false;
    },
    SET_UPLOAD_REQUEST_SUCCES(state: NS.IViewingState): void {
        state.activeUploadRequest = false;
        state.failedUploadRequest = false;
        state.successUploadRequest = true;
    },
    SET_UPLOAD_REQUEST_RESET(state: NS.IViewingState): void {
        state.activeUploadRequest = false;
        state.failedUploadRequest = false;
        state.successUploadRequest = false;
    },
}

/** Реализация мутаций модуля просмотра */
export default mutations;